import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter68.json";
import Head from "next/head";
export default function Chapter_68() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>

      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Abrahamic faiths, Hinduism, cosmic dualism, Brahman, creation, destruction, good, evil, divine play, spirituality, morality, destiny, cycles of existence, spiritual warfare, harmony"
        ></meta>
        <meta
          property="og:title"
          content="Two Visions of the Cosmos: Abrahamic Dualism vs. Hindu Divine Play"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="The Abrahamic faiths see existence as a cosmic war between absolute good and evil, while Hinduism envisions the universe as Brahman’s cyclical dance of creation and destruction. These divergent perspectives shape morality, destiny, and spiritual purpose—one emphasizing divine obedience against evil, the other embracing balance within the eternal rhythm of opposing yet complementary forces."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=68"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=68"
        ></meta>
        <meta
          name="twitter:title"
          content="Aleister Crowley: Occult Visionary and the Bridge to Modern Mysticism"
        ></meta>
        <meta
          name="twitter:description"
          content="Abrahamic faiths frame life as a moral battle between God and evil. Hinduism sees reality as Brahman’s eternal play, where creation and destruction are complementary. These contrasting visions redefine morality, destiny, and the divine—one calls for spiritual warfare, the other for harmony within the infinite cycles of existence."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=68" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
